import { ApiProperty } from "@nestjs/swagger";

export class DeHeadingSampleDto{
    @ApiProperty()
    deheadingSampleId: number;
    @ApiProperty()
    sampleNo: number;
    @ApiProperty()
    jobNo: string;
    @ApiProperty()
    batchNo: string;
    @ApiProperty()
    temperature: number;
    @ApiProperty()
    discoloration: string;
    @ApiProperty()
    deterioration: string;
    @ApiProperty()
    softTail: string;
    @ApiProperty()
    blackTail: string;
    @ApiProperty()
    brokenOrUnUsable: string;
    @ApiProperty()
    improperDeheading: string;
    @ApiProperty()
    brownMeat: string;
    @ApiProperty()
    hangingMeatOrThroat: string;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    versionFlag: number;
}